import { useCallback, useEffect, useRef } from 'react';
import { tGameType } from 'common/modules/ReactShared';

interface IMetrics {
  readonly attempts: number;
  readonly timeSpent: number;
  addAttempt: () => void;
  startTiming: () => void;
  stopTiming: () => void;
}

function getSecondsNumber(ms: number): number {
  return Math.floor(ms / 1000);
}

const useTaskGamesMetrics = (gameType: tGameType): IMetrics => {
  const startTime = useRef<number | null>(null);

  const startTiming = useCallback(() => {
    startTime.current = Date.now();
  }, []);

  const stopTiming = useCallback(() => {
    startTime.current = null;
  }, []);

  const attempts = useRef<number>(0);
  const addAttempt = useCallback(() => {
    attempts.current += 1;
  }, []);

  useEffect(() => {
    startTiming();
    attempts.current = 0;
  }, [gameType, startTiming]);

  const metrics = {
    get timeSpent() {
      if (!startTime.current) return 0;
      return getSecondsNumber(Date.now() - startTime.current);
    },
    startTiming,
    stopTiming,
    get attempts() {
      return attempts.current;
    },
    addAttempt
  };

  return metrics;
};

export { useTaskGamesMetrics };
export type { IMetrics };
